/*
 * filterSelect — Alpine component for the .mh-filter-select disclosure dropdown.
 *
 * State: open/closed only. Selection state lives on the native <input
 * type="checkbox"> elements inside the panel — they post with the
 * surrounding form natively, and screen readers announce them with
 * native checkbox semantics. We don't shadow that state into Alpine.
 *
 * Keyboard model (matches WAI-ARIA Authoring Practices for a disclosure
 * widget wrapping a group of native form controls):
 *   - Trigger: Enter/Space toggles. ArrowDown opens + focuses first
 *     checkbox; ArrowUp opens + focuses last.
 *   - Panel:   ArrowDown/Up roving focus. Home/End jump to first/last.
 *              Space toggles the focused checkbox (native browser behaviour).
 *              Escape closes + returns focus to the trigger.
 *   - Outside click closes.
 */
export default function filterSelect() {
    return {
        open: false,

        get expandedAttr() {
            return String(this.open);
        },

        toggle() {
            this.open = !this.open;
        },

        close() {
            this.open = false;
        },

        getItems() {
            return this.$refs.panel
                ? Array.from(
                      this.$refs.panel.querySelectorAll(
                          'input[type="checkbox"]:not(:disabled)',
                      ),
                  )
                : [];
        },

        focusItem(index) {
            const items = this.getItems();
            if (items.length === 0) return;
            const wrapped = (index + items.length) % items.length;
            items[wrapped].focus();
        },

        focusFirst() {
            this.focusItem(0);
        },

        focusLast() {
            this.focusItem(-1);
        },

        focusNext() {
            const items = this.getItems();
            if (items.length === 0) return;
            const active = items.indexOf(document.activeElement);
            this.focusItem(active + 1);
        },

        focusPrev() {
            const items = this.getItems();
            if (items.length === 0) return;
            const active = items.indexOf(document.activeElement);
            this.focusItem(active === -1 ? items.length - 1 : active - 1);
        },

        openAndFocusFirst() {
            this.open = true;
            this.$nextTick(() => this.focusFirst());
        },

        openAndFocusLast() {
            this.open = true;
            this.$nextTick(() => this.focusLast());
        },

        handleEscape() {
            if (this.open) {
                this.close();
                this.$refs.trigger.focus();
            }
        },

        init() {},
        destroy() {},
    };
}
